import {COMPETITION_CONTAINER} from "../../../../../containers/competition-container/competition-container.consts";
import {computed} from "mobx";
import {NavigationTabsModuleLiveBadgeRequestParams} from "../../../assests/navigation-tabs-module.live-badge.request-params";
import {StandingsTabModel} from "../standings.tab-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionStandingsPageLinkModel} from "../../../../../containers/competition-container/pages/standings-page/models/competition-standings-page.link-model";

export class CompetitionStandingsPageTabModel extends StandingsTabModel {
  @computed get linkModel(): CompetitionStandingsPageLinkModel {
    const linkModel: CompetitionStandingsPageLinkModel = new CompetitionStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, COMPETITION_CONTAINER.FILTERS.standings, null, this.entity.isFollow);

    return linkModel;
  }

  get isActive(): Boolean {
    return this.currentLinkModel.params.page === COMPETITION_CONTAINER.FILTERS.standings
  }

  get iconSource(): NavigationTabsModuleLiveBadgeRequestParams {
    return new NavigationTabsModuleLiveBadgeRequestParams(38, 14);
  }

  get hasIcon(): Boolean {
    return this.entity.hasLiveStandings;
  }

  get isIconFirst(): Boolean {
    return false;
  }
  get analyticsEntityType(): Object {
    return ANALYTICS.ENTITY_TYPES.competition;
  }

  get elementId(): String {
    return 'navigation-tabs_competition_standings';
  }
}
